module.exports = __webpack_public_path__ + "media/images/home_cat_placeholder-9d4787ef7535ae993c643f9cce3627a7.jpg";